import React, { Component, Fragment } from 'react';
import {NavLink} from 'react-router-dom';
import { findDOMNode } from 'react-dom';
import $ from "jquery";

import { TimePicker, DatePicker } from 'material-ui-pickers';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Switch from '@material-ui/core/Switch';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';

import {stableSort, getSorting, statusTextClass, roundTime, getCaretIndex} from '../Common/helpers';
import {validateForm, blurValidations} from '../Common/formValidator';
import { Editor } from '../Common/Editor';
import EnhancedTableHead from '../Common/TableHead/EnhancedTableHead';
import FieldsHelper from '../Common/FieldOptions/FieldsHelper';
import ModalBox from '../Common/Modals/ModalBox';
import AddEditSegmentation from '../Segmentation/AddEditSegmentation';

import { API } from '../../ws/constants';
import './style.css';

var moment = require('moment');

class AddEditCommunication extends Component {
    date = moment();
    state = {
        communicationId:this.props.props.match.params.id
        ,openModal:false
        ,bigModal:false
        ,modalClass:false
        ,order:'desc'
        ,orderBy:'DateSent'
        ,page:0
        ,rowsPerPage:5
        ,modalHtml: ""
        ,modalCallBack: this.modalCallBack
        ,hideModalButtons: false
        ,editable: false
        ,somethingWasEdited: false
        ,messageWasEdited: false
        ,fetchTypes:null
        ,fetchFrequencies:null
        ,fetchSegmentationList:null
        ,communicationData:null
        ,loading:false
        ,addEditTitle:"Nova Comunicação"
        ,typeId:""
        ,name:""
        ,subject:""
        ,message:""
        ,isHtml:"0"
        ,sender:""
        ,senderName:""
        ,replyTo:""
        ,replyToName:""
        ,scheduleCommunication:"0"
        ,segmentationList:0
        ,sendDate:this.date
        ,sendTime:this.date
        ,sendType:"specificDate"
        ,frequency:"0"
        ,freqTime:this.date
        ,startDate:this.date
        ,isSystem:null
        ,systemCommName:null
        ,systemCommDescription:null
        ,description:""
        ,notes:""
        ,isActive:"1"
    };
    validateSender = ["", " validEmail", " validPhone", " validPhone"];
    accessLevel = this.props.loginData.AccessLevel;

    componentWillMount() {
        const isNew = isNaN(this.state.communicationId);
        const { isAdmin, loginData } = this.props;   
        
        if(!(isAdmin || loginData.profile.Communications) || (isNew && !(isAdmin || loginData.profile.Communications)))
            this.props.props.history.push('/Communications');

        return;
    }

    componentDidMount() {
        const { isAdmin, loginData } = this.props;   
        const isNew = isNaN(this.state.communicationId);
        const fetches = [
            fetch(API + "getcommunicationtypes"),
            fetch(API + "getperiodicityfrequencies")
        ];

        if(!isNew){
            fetches.push(fetch(API + "getcommunications&getbyid="+this.state.communicationId));
            fetches.push(fetch(API + "getsegmentationlist"));
        }

        Promise.all(fetches)
        .then(responses => Promise.all(responses.map(r => r.json())))
        .then((data) => {
            const newState = {
                editable: Boolean(isAdmin || (loginData.profile.Communications && loginData.profile.Communications.permission === 1)),
                fetchTypes: data[0].data
            };

            if(!isNew && data[2].shortmsg === "NOK"){
                this.props.props.history.push('/Communications');
                return;
            }else if(!isNew && data[2].shortmsg === "OK"){
                const date = moment();
                newState.fetchFrequencies = data[1].data
                newState.communicationData = data[2].data[0];
                newState.typeId = newState.communicationData.TypeId;
                newState.name = newState.communicationData.Name;
                newState.subject = newState.communicationData.Subject;
                newState.message = newState.communicationData.Message;
                newState.isHtml = newState.communicationData.MessageIsHtml;
                newState.sender = newState.communicationData.Sender;
                newState.senderName = newState.communicationData.SenderName;
                newState.replyTo = newState.communicationData.ReplyTo;
                newState.replyToName = newState.communicationData.ReplyToName;
                newState.segmentationList = newState.communicationData.SegmentationListId;
                newState.sendDate = newState.communicationData.SendDate !== null ? moment(newState.communicationData.SendDate) : date;
                newState.sendTime = newState.communicationData.SendDate !== null ? moment(newState.communicationData.SendDate) : roundTime(date, moment.duration(10, "minutes"), "round");
                newState.sendType = newState.communicationData.FrequencyId && newState.communicationData.FrequencyId !== "0" ? "recurrent" : "specificDate";
                newState.scheduleCommunication = (newState.communicationData.FrequencyId && newState.communicationData.FrequencyId !== "0") || newState.communicationData.SendDate ? "1" : "0";
                newState.frequency = newState.communicationData.FrequencyId !== null ? newState.communicationData.FrequencyId : "0";
                newState.freqTime = newState.communicationData.FrequencyTime !== null ? moment(date.format('YYYY/MM/DD') + " " + newState.communicationData.FrequencyTime) : roundTime(date, moment.duration(10, "minutes"), "round");
                newState.startdate = newState.communicationData.NextSendDate !== null ? newState.communicationData.NextSendDate : date;
                newState.isSystem = newState.communicationData.IsSystem;
                newState.systemCommName = newState.communicationData.SystemCommName;
                newState.systemCommDescription = newState.communicationData.SystemCommDescription;
                newState.description = newState.communicationData.Description;
                newState.notes = newState.communicationData.Notes;
                newState.isActive = newState.communicationData.IsActive != null ? newState.communicationData.IsActive : "1";
                newState.fetchSegmentationList = data[3].data
            }
            this.setState(newState);
        });
        blurValidations($(findDOMNode(this.refs.editForm)), { validateHiddenFields: true, showErrorMessage: true, dumbValidations: false });
    }

    handleTitleChange = (e) => this.setState({ [e.target.id]: e.target.value, addEditTitle: e.target.value, somethingWasEdited:true });
    handleFieldChange = (e) => this.setState({ [e.target.id]: e.target.value, somethingWasEdited:true });
    handleMessageChange = (message) => {
        this.setState({ message, messageWasEdited:true, somethingWasEdited:true })
    };
    handleSendDateChange = date => this.setState({ sendDate: date });
    handleStartDateChange = date => this.setState({ startDate: date });
    handleSelectChange = (e) => this.setState({ [e.target.name]: e.target.value, somethingWasEdited:true });
    handleToggle = (e, value) => this.setState({ [e.target.id]: value ? "1" : "0", somethingWasEdited:true });
    handleSendTimeChange = (value) => {
        value = roundTime(value, moment.duration(10, "minutes"), "round");
        this.setState({sendTime: value, somethingWasEdited:true});
    }
    handleFreqTimeChange = (value) => {
        value = roundTime(value, moment.duration(10, "minutes"), "round");
        this.setState({freqTime: value, somethingWasEdited:true});
    }
    
    handleSendTypeChange = (e) => {
        const newState = {
            sendType: e.target.value,
            somethingWasEdited:true
        }

        if(e.target.value === "specificDate"){
            newState.frequency = "0";
        }

        this.setState(newState);
    };
    
    handleScheduleMessageChange = (e, value) => {
        const newState = {
            scheduleCommunication: value ? "1" : "0",
            somethingWasEdited: true
        }

        if(!value){
            newState.frequency = "0";
        }

        this.setState(newState);
    };


    handleSave = () => {
        if(!this.state.somethingWasEdited && !this.state.messageWasEdited)
            return;

        if(validateForm($(findDOMNode(this.refs.editForm)), { validateHiddenFields: true, showErrorMessage: true, dumbValidations: false }) && this.state.typeId.length > 0){
            let sendDate = ""
                ,sendTime = ""
                ,freqTime = this.state.freqTime.format("HH:mm:00")
                ,nextSendDate = "0000-00-00 00:00:00";

            this.setState({loading:true});
            if(this.state.scheduleCommunication === "1"){
                if(this.state.sendType === "specificDate"){
                    sendDate = this.state.sendDate.format("YYYY-MM-DD");
                    sendTime = this.state.sendTime.format("HH:mm:00");
                    nextSendDate = sendDate + " " + sendTime;
                }else{
                    nextSendDate = this.state.startDate.format("YYYY-MM-DD") + " " + freqTime;
                }
            }
            console.log("this.state", this.state);
            fetch(API + "savecommunication", {
                method: 'POST'
                ,headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
                ,body: JSON.stringify({
                    communicationid:this.state.communicationId
                    ,ishtml:this.state.isHtml
                    ,typeid:this.state.typeId
                    ,name:this.state.name.trim()
                    ,subject:this.state.subject.trim()
                    ,message:this.state.message.trim()
                    ,sender:this.state.sender.trim()
                    ,sendername:this.state.senderName.trim()
                    ,replyto:this.state.replyTo.trim()
                    ,replytoname:this.state.replyToName.trim()
                    ,segmentationlist: this.state.segmentationList
                    ,senddate:sendDate
                    ,sendtime:sendTime
                    ,frequency:this.state.frequency
                    ,frequencytime:freqTime
                    ,nextsenddate:nextSendDate
                    ,description:this.state.description.trim()
                    ,notes:this.state.notes.trim()
                    ,isactive:this.state.isActive
                    ,cur_userid:this.props.loginData.Id
                    ,cur_username:this.props.loginData.Name
                })
            })
            .then(response => response.json())
            .then(result => {
                const newId = result.data && result.data.length && result.data[0];
                const newState = {
                    modalHtml: <div className="col-12"><h2>{result.shortmsg === "OK" ? "Sucesso" : "Erro"}</h2><p>{result.message}</p></div>
                    , modalCallBack: this.modalCallBack
                    , openModal: true
                    , loading:false
                    , somethingWasEdited:false
                    , messageWasEdited:false
                };

                if(newId){
                    newState.communicationId = newId;

                    fetch(API + "getsegmentationlist")
                    .then(response => response.json())
                    .then(result => this.setState({...newState, fetchSegmentationList: result.data}));
                }

                this.setState(newState);
            });
        }
    }

    handleChangePage = (event, page) => {
        this.setState({ page }, this.handleShowHistory);
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value }, this.handleShowHistory);
    };

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy }, this.handleShowHistory);
    };

    handleShowHistory = () => {
        this.setState({ loading:true });
        const { order, orderBy, rowsPerPage, page } = this.state
        , headerRows = [
            { id: 'Result', active: true, numeric: false, label: 'Resultado' },
            { id: 'TypeName', numeric: false, label: 'Tipo' },
            { id: 'ClientName', numeric: false, label: 'Cliente' },
            { id: 'Receiver', numeric: false, label: 'Contacto' },
            { id: 'Subject', numeric: false, label: 'Assunto' },
            { id: 'Message', numeric: false, label: 'Mensagem' },
            { id: 'DateSent', label: 'Data do envio' },
        ];

        fetch(API + "getcommunicationlog&getbyid="+this.state.communicationId)
        .then(response => response.json())
        .then(result => {
            const communications = result.data;
            const modalHtml =
            <div className="col-12">
                <div className="row">
                    <div className="col-12">
                        <h2>Registo de comunicação</h2>
                        <Table className="responsiveTable customTable">
                            <EnhancedTableHead
                                className="tableRow tableHeader"
                                headerRows={headerRows}
                                order={order}
                                orderBy={orderBy}
                                onRequestSort={this.handleRequestSort}
                                rowCount={communications.length}>
                            </EnhancedTableHead>
                            <TableBody>
                                {stableSort(communications, getSorting(order, orderBy))
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map(communication =>
                                <TableRow key={communication.Id} className="tableRow">
                                    <TableCell data-title="Resultado" className="tableCell"><span className={statusTextClass(communication.StatusId)}>{communication.Result}</span></TableCell>
                                    <TableCell data-title="Tipo" className="tableCell">{communication.TypeName}</TableCell>
                                    <TableCell data-title="Cliente" className="tableCell"><NavLink to={"/Clients/"+communication.ClientId}>{communication.ClientName}</NavLink></TableCell>
                                    <TableCell data-title="Contacto" className="tableCell">{communication.Receiver}</TableCell>
                                    <TableCell data-title="Assunto" className="tableCell">{communication.Subject}</TableCell>
                                    <TableCell data-title="Mensagem" className="tableCell"><div className="logMessage">{communication.Message}</div></TableCell>
                                    <TableCell data-title="Data do envio" className="tableCell noWrap">{communication.DateSent}</TableCell>
                                </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={communications.length}
                            rowsPerPage={rowsPerPage}
                            labelRowsPerPage="Linhas por página:"
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                            page={page}
                            backIconButtonProps={{
                                'aria-label': 'Página anterior',
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'Próxima página',
                            }}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        />
                    </div>
                </div>
            </div>;

            this.setState({
                modalHtml: modalHtml
                , modalCallBack: this.historyModalCallBack
                , bigModal: true
                , openModal: true
                , loading: false
            });
        });
    }

    handleShowPreview = (e) => {
        this.setState({loading: true});

        fetch(API + "showmessagepreview&communicationid="+this.state.communicationId)
        .then(response => response.json())
        .then(result => {
            const { isHtml, typeId } = this.state;
            const isSMS = typeId === "2";
            const emailClass = isHtml === "1" ? ' desktopImage' : '';
            
            const preview = result.data;
            const modalHtml = isSMS ? <div className="col-12">
                <h2>Mensagem final {this.state.messageWasEdited && <span className="dangerText">(Unsaved Message)</span>}</h2>
                <div className="phoneImage fieldHolder">
                    <TextField fullWidth={true}
                               defaultValue={preview}
                               disabled={true}
                               multiline={true}
                               rows={20} />
                </div>
                <p>Número de caracteres: {preview.length}</p>
            </div> : <div className="col-12">
                <h2>Mensagem final {this.state.messageWasEdited && <span className="dangerText">(Unsaved Message)</span>}</h2>
                <div className={"fieldHolder" + emailClass}>
                    <iframe title="emailPreview" className="emailPreview" srcdoc={preview}></iframe>
                </div>
            </div>;

            this.setState({
                modalHtml: modalHtml
                , bigModal: isHtml === "1"
                , openModal: true
                , loading:false
                , modalCallBack: this.modalCallBack
            });
        });
    }

    handleSendTest = () => {
        const modalHtml = <div className="col-12">
            <h2>Enviar Teste  {this.state.messageWasEdited && <span className="dangerText">(Unsaved Message)</span>}</h2>
            <div className="row">
                <div className="col-8 align-center fieldHolder required">
                    <TextField fullWidth
                                id="testContact"
                                onChange={this.handleFieldChange}
                                label="Contacto"
                                placeholder="Introduza o Contacto" />
                </div>
            </div>
        </div>;

        this.setState({
            modalHtml: modalHtml
            , openModal: true
            , loading:false
            , modalCallBack: this.sendTest
        });
    }

    handleSendCommunication = () => {
        this.setState({ loading: true, openModal: false });
        fetch(API + "sendschedulemessages&communicationid="+this.state.communicationId+"&listid="+this.state.segmentationList)
        .then(response => response.json())
        .then(result => {
            this.setState({ 
                modalHtml: <div className="col-12"><h2>{result.shortmsg === "OK" ? "Sucesso" : "Erro"}</h2><p>{result.message}</p></div>,
                openModal: true, 
                loading:false,
                modalCallBack: this.modalCallBack
            });
        });
    }

    sendTest = (result) => {
        const { testContact } = this.state;

        if(!result){
            this.setState({ openModal: false });
            return;
        }
        
        if(!testContact){
            this.setState({
                modalHtml: <div className="col-12">
                <h2>Enviar Teste</h2>
                    <div className="row">
                        <div className="col-8 align-center fieldHolder required hasError">
                            <TextField fullWidth
                                        id="testContact"
                                        onChange={this.handleFieldChange}
                                        label="Contacto"
                                        placeholder="Introduza o Contacto" />
                            <p className="errorMessage "><span>Este campo não pode estar vazio</span></p>
                        </div>
                    </div>
                </div>
            });
            return;
        }

        this.setState({ loading: true, openModal: false });
        fetch(API + "showmessagepreview&communicationid="+this.state.communicationId+"&sendtest="+testContact)
        .then(response => response.json())
        .then(result => {
            this.setState({ 
                modalHtml: <div className="col-12"><h2>{result.shortmsg === "OK" ? "Sucesso" : "Erro"}</h2><p>{result.message}</p></div>,
                openModal: true, 
                loading:false,
                modalCallBack: this.modalCallBack
            });
        });
    }

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ 
            openModal: keepModalOpen, 
            hideModalButtons: false,
            modalClass: '',
            bigModal: false,
        });
    }

    historyModalCallBack = (result, keepModalOpen) => {
        this.setState({ 
            openModal: keepModalOpen,
            modalClass: '',
            bigModal: false,
        });
    }

    handleDelete = (e) => {
        if(window.confirm("Tem a certeza que quer apagar esta comunicação?")){
            this.setState({loading:true});
            fetch(API + 'deletecommunication&communicationid=' + this.state.communicationId + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                this.setState({
                modalHtml: <div className="col-12"><h2>{result.shortmsg === "OK" ? "Sucesso" : "Erro"}</h2><p>{result.message}</p></div>
                , modalCallBack: this.modalCallBack
                , openModal: true
                , loading:false });
            });
        }
    }

    createNewCommunicationList = () => {
        this.setState({
            modalHtml: <AddEditSegmentation 
                        id="New" 
                        updateSegmentationsList={this.updateSegmentationsList} 
                        closeModal={this.closeSegmentationModal} 
                        isAdmin={this.props.isAdmin} 
                        loginData={this.props.loginData} />
            , modalCallBack: this.modalCallBack
            , hideModalButtons: true
            , openModal: true
        });
    }

    editCommunicationList = () => {
        this.setState({
            modalHtml: <AddEditSegmentation 
                        id={this.state.segmentationList} 
                        updateSegmentationsList={this.updateSegmentationsList} 
                        closeModal={this.closeSegmentationModal} 
                        isAdmin={this.props.isAdmin} 
                        loginData={this.props.loginData} />
            , modalCallBack: this.modalCallBack
            , hideModalButtons: true
            , openModal: true
        });
    }

    updateSegmentationsList = (saveResult) => {
        fetch(API + "getsegmentationlist")
        .then(response => response.json())
        .then(result => {
            this.setState({ 
                fetchSegmentationList: result.data 
                // , modalHtml: <div className="col-12"><h2>{saveResult.shortmsg === "OK" ? "Sucesso" : "Erro"}</h2><p>{saveResult.message}</p></div>
                // , modalCallBack: this.modalCallBack
                // , openModal: true
                , messageWasEdited:true
            })
        });
    }

    closeSegmentationModal = () => {
        this.setState({ openModal: false, hideModalButtons: false });
    }

    renderTypeOptions = (e) => {
        const type = this.state.fetchTypes;
        if(type===null)
            return;

        const items = [<MenuItem value="0" key="0" disabled={true}>Escolha o tipo</MenuItem>];
        for (let i=0,n=type.length;i<n;i++) {
            items.push(<MenuItem value={type[i].Id}
                                 key={type[i].Id}>{type[i].Name}</MenuItem>);
        }
        return items;
    }

    renderFrequencyOptions = (e) => {
        const freq = this.state.fetchFrequencies;
        if(freq===null)
            return;

        const items = [<MenuItem value="0" key="0" disabled={true}>Escolha a frequência</MenuItem>];
        for (let i=0,n=freq.length;i<n;i++) {
            items.push(<MenuItem value={freq[i].Id}
                                 checked={this.state.frequency && this.state.frequency.indexOf(freq[i].Id) > -1}
                                 className="insetItem"
                                 key={freq[i].Id}>{freq[i].Name}</MenuItem>);
        }
        return items;
    }

    renderSegmentationOptions = (e) => {
        const segmentation = this.state.fetchSegmentationList;
        if(segmentation===null)
            return;
        
        const items = [<MenuItem value="0" key="0" disabled={true}>Escolha a lista</MenuItem>];
        for (let i=0,n=segmentation.length;i<n;i++) {
            items.push(<MenuItem value={segmentation[i].Id}
                                 checked={this.state.segmentationList && this.state.segmentationList.indexOf(segmentation[i].Id) > -1}
                                 className="insetItem"
                                 key={segmentation[i].Id}>{segmentation[i].Name}</MenuItem>);
        }
        return items;
    }

    addFieldValueToInput = (value, targetInput) => {
        const input = document.getElementById(targetInput) || document.getElementsByName(targetInput)[0];
        const editor = document.getElementsByClassName("se-wrapper-inner se-wrapper-wysiwyg sun-editor-editable")[0];
        const caretPosition = editor ? getCaretIndex(editor, input) : input.selectionStart
              , inputValue = input.value
              , firstPart = inputValue.slice(0, caretPosition)
              , secondPart = inputValue.slice(caretPosition)
              , finalValue = firstPart + value + secondPart;

        console.log("caretPosition", caretPosition);
        console.log("inputValue", inputValue);
        console.log("firstPart", firstPart);
        console.log("secondPart", secondPart);
        console.log("finalValue", finalValue);

        this.setState({[targetInput]: finalValue});
    }

    render() {
        const { isAdmin, loginData } = this.props;   
        const { isSystem, scheduleCommunication, sendType } = this.state
              , systemDisabled = !!isSystem && this.accessLevel > 0
              , optsTypes = this.renderTypeOptions()
              , optsFrequency = this.renderFrequencyOptions()
              , optsSegmentationList = this.renderSegmentationOptions()
              , addEditTitle = this.state.communicationId > 0 && this.state.communicationData!==null ? this.state.communicationData.Name : this.state.addEditTitle
              , loadingClass = this.state.loading ? " ajaxLoading" : ""
              , fieldSelects = [
                  {
                      selectId:"clientFields"
                      , selectText:"Campos de cliente"
                      , selectOptions: [
                          {value:"ClientId", text:"Id interno"}
                          , {value:"ClientFirstName", text:"Primeiro nome"}
                          , {value:"ClientLastName", text:"Último nome"}
                          , {value:"ClientProfession", text:"Profissão"}
                          , {value:"ClientGender", text:"Sexo"}
                          , {value:"ClientBirthDate", text:"Data de nascimento"}
                          , {value:"ClientHomePhoneNumber", text:"Telefone de casa"}
                          , {value:"ClientPhoneNumber", text:"Telemóvel"}
                          , {value:"ClientEmail", text:"Email"}
                          , {value:"ClientDateSince", text:"Data Inscrição"}
                      ]
                  }
                  , {
                      selectId:"appFields"
                      , selectText:"Campos de marcação"
                      , selectOptions: [
                          {value:"Date", text:"Data"}
                          , {value:"Hours", text:"Horas"}
                          , {value:"FullInfoWithStaffFullName", text:"Toda info com nome completo do funcionário"}
                          , {value:"FullInfoWithStaffFirstName", text:"Toda info com primeiro nome do funcionário"}
                          , {value:"FullInfoWithoutStaff", text:"Toda info sem funcionário"}
                      ]
                  }
                  , {
                      selectId:"miscFields"
                      , selectText:"Outros campos"
                      , selectOptions: [
                          {value:"Services", text:"Serviços"}
                          , {value:"StoreName", text:"Nome da loja"}
                          , {value:"StoreCountry", text:"País da loja"}
                          , {value:"StoreCity", text:"Cidade da loja"}
                          , {value:"StoreAddress", text:"Endereço da loja"}
                          , {value:"StaffFirstName", text:"Primeiro Nome do funcionário"}
                          , {value:"StaffLastName", text:"Último Nome do funcionário"}
                          , {value:"StaffFullName", text:"Nome Completo do funcionário"}
                          , {value:"StaffPicture", text:"Fotografia do funcionário"}
                      ]
                  }
              ];

        return (
            <div id="addEditCommunicationsPage" ref="editForm" className={"form addEditPage" + loadingClass}>
                <div className="row">
                    <div className="col-12">
                        <h1><i className="fa fa-mail-bulk"></i> {addEditTitle} {isSystem && <b className="dangerText">*</b>}
                            <span className="float-right">
                                <FormControlLabel
                                    control={
                                        <Switch
                                            id="isActive"
                                            checked={!!+this.state.isActive}
                                            disabled={!(this.state.editable && (isAdmin || (loginData.profile.Communications.isActive && loginData.profile.Communications.isActive.permission === 1)))}
                                            onChange={this.handleToggle}
                                            color="primary"/>
                                        }
                                    label="Ativo"/>
                            </span>
                        </h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-9">
                        { isSystem &&
                            <Fragment>
                                <p className="smallText"><span className="dangerText">*Esta é uma mensagem de sistema.</span> Ligação com '{this.state.systemCommName}'</p>
                                <p className="smallText">Descrição: '{this.state.systemCommDescription}'</p>
                            </Fragment>
                        }
                    </div>
                    { this.state.communicationId !== "New" &&
                        <div className="col-md-3 text-right">
                            <Button onClick={this.handleShowHistory} className="button" variant="contained" color="primary">Ver histórico</Button>
                        </div>
                    }
                </div>
                { this.state.communicationId !== "New" &&
                <div className="row">
                    <div className="col-12">
                        <hr />
                    </div>
                </div>
                }
                <div className="row">
                    <div className="col-12 col-md-9 fieldHolder required">
                        <TextField fullWidth={true}
                                   id="name"
                                   value={this.state.name}
                                   onChange={this.handleTitleChange}
                                   label="Designação"
                                   placeholder="Introduza o Nome"
                                   disabled={!this.state.editable}
                                   data-empty-error-message="Este campo não pode estar vazio" />
                    </div>
                    <div className="col-12 col-md-3 fieldHolder required selectField">
                        <FormControl fullWidth={true}>
                            <InputLabel htmlFor="typeId">Tipo de Comunicação</InputLabel>
                            <Select id="typeId"
                                    name="typeId"
                                    value={this.state.typeId}
                                    onChange={this.handleSelectChange}
                                    disabled={systemDisabled || !this.state.editable}
                                    data-empty-error-message="Este campo não pode estar vazio">
                              {optsTypes}
                            </Select>
                        </FormControl>
                    </div>
                </div>
                <div className="row">
                    <div className={"col-12 col-md-4 fieldHolder required" + this.validateSender[this.state.typeId]}>
                        <TextField fullWidth={true}
                                   id="sender"
                                   value={this.state.sender}
                                   onChange={this.handleFieldChange}
                                   label="Remetente"
                                   placeholder="Introduza o Remetente"
                                   disabled={systemDisabled}
                                   data-empty-error-message="Este campo não pode estar vazio" />
                    </div>
                    <div className="col-12 col-md-2 smallGutter fieldHolder required">
                        <TextField fullWidth={true}
                                   id="senderName"
                                   value={this.state.senderName}
                                   onChange={this.handleFieldChange}
                                   label="Nome Remetente"
                                   placeholder="Introduza o nome do Remetente"
                                   disabled={systemDisabled}
                                   data-empty-error-message="Este campo não pode estar vazio" />
                    </div>
                    <div className={"col-12 col-md-4 fieldHolder required" + this.validateSender[this.state.typeId]}>
                        <TextField fullWidth={true}
                                   id="replyTo"
                                   value={this.state.replyTo}
                                   onChange={this.handleFieldChange}
                                   label="Responder Para"
                                   placeholder="Introduza o Email de resposta"
                                   disabled={this.state.typeId !== "1"}
                                   data-empty-error-message="Este campo não pode estar vazio" />
                    </div>
                    <div className="col-12 col-md-2 smallGutter-left fieldHolder required">
                        <TextField fullWidth={true}
                                   id="replyToName"
                                   value={this.state.replyToName}
                                   onChange={this.handleFieldChange}
                                   label="Nome de Resposta"
                                   placeholder="Introduza o Nome de resposta"
                                   disabled={this.state.typeId !== "1"}
                                   data-empty-error-message="Este campo não pode estar vazio" />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-md-8">
                        <FieldsHelper isVisible={false} disabled={!this.state.editable} addFieldValueToInput={this.addFieldValueToInput} targetInput={"subject"} fieldSelects={fieldSelects} />
                        <div className="row">
                            <div className="col-12 fieldHolder required">
                                <TextField fullWidth={true}
                                           id="subject"
                                           value={this.state.subject}
                                           onChange={this.handleFieldChange}
                                           label="Assunto"
                                           placeholder="Introduza o Assunto"
                                           disabled={!this.state.editable}
                                           data-empty-error-message="Este campo não pode estar vazio" />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <span>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                id="isHtml"
                                                checked={!!+this.state.isHtml}
                                                disabled={!this.state.editable}
                                                onChange={this.handleToggle}
                                                color="primary"/>
                                            }
                                        label="Mensagem é HTML"/>
                                </span>
                            </div>
                        </div>
                        <FieldsHelper isVisible={true} disabled={!this.state.editable} addFieldValueToInput={this.addFieldValueToInput} targetInput={"message"} fieldSelects={fieldSelects} />
                        <div className="row">
                            <div className={"col-12 fieldHolder editorHolder"}>
                                <InputLabel htmlFor="message">Introduza a Mensagem</InputLabel>
                                { this.state.isHtml === "1" ?
                                    <Editor
                                        id="message"
                                        name="message"
                                        height="450"
                                        value={this.state.message}
                                        onChange={this.handleMessageChange}
                                        disabled={!this.state.editable}
                                        placeholder="Introduza a Mensagem"
                                    />
                                    :
                                    <TextField 
                                        fullWidth={true}
                                        id="message"
                                        value={this.state.message}
                                        onChange={this.handleFieldChange}
                                        disabled={!this.state.editable}
                                        multiline={true}
                                        rows={20}
                                        placeholder="Introduza a Mensagem"
                                    />
                                }
                           </div>
                       </div>
                        {this.state.editable && this.state.message !== "" &&
                            <div className="row">
                                <div className="col-12 fieldHolder text-center">
                                    <Button onClick={this.handleShowPreview} className="float-left" variant="contained" color="primary">Pré-visualizar Mensagem</Button>
                                    {this.state.messageWasEdited && <span className="dangerText">Unsaved Message</span>}
                                    <Button onClick={this.handleSendTest} className="float-right" variant="contained">Enviar Teste</Button>
                                </div>
                            </div>
                        }
                    </div>
                    {this.state.editable && !isSystem && this.state.communicationId !== "New" &&
                    <div className={"col-12 col-md-4 smallMarginTop" + (systemDisabled ? " hidden" : "")}>
                        <h2>Destinatários 
                            { (isAdmin || (loginData.profile.Communications && loginData.profile.Communications.CreateList)) && 
                                <span className="float-right">
                                    <Tooltip
                                        title={"Adicionar Lista"}
                                        enterDelay={200}>
                                        <span>
                                            <button onClick={this.createNewCommunicationList} type="button" className="actionButton success"><i className="fa fa-plus"></i></button>
                                        </span>
                                    </Tooltip>
                                </span>
                            }</h2>
                        <div className="row">
                            <div className="col-12 col-md-10 fieldHolder required selectField">
                                <FormControl fullWidth={true}>
                                    <InputLabel htmlFor="segmentationList">Lista de Clientes</InputLabel>
                                    <Select id="segmentationList"
                                            name="segmentationList"
                                            value={this.state.segmentationList}
                                            onChange={this.handleSelectChange}
                                            disabled={!this.state.editable}
                                            data-empty-error-message="Este campo não pode estar vazio">
                                    {optsSegmentationList}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="col-12 col-md-2 noPadding">
                                <Tooltip
                                    title={"Editar Lista"}
                                    enterDelay={200}
                                    disabled={!this.state.segmentationList}>
                                    <span className="editList">
                                        <button onClick={this.editCommunicationList} type="button" className="actionButton warning" disabled={!this.state.segmentationList}><i className="fa fa-pencil-alt"></i></button>
                                    </span>
                                </Tooltip>
                            </div>
                        </div>
                        <h2 className="publicationHeader">Publicação</h2>
                        <div className="row">
                            <div className="col-12 col-md-6 buttonsHolder">
                                <Button onClick={this.handleSendCommunication} className="button" variant="contained" color="primary" disabled={!!+scheduleCommunication || !this.state.segmentationList}>Enviar Agora</Button>
                            </div>
                            <div className="col-12 col-md-6 fieldHolder scheduleCommunication noPadding-left">
                                <span>Ou</span>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            id="scheduleCommunication"
                                            checked={!!+scheduleCommunication}
                                            disabled={!this.state.editable || !this.state.segmentationList}
                                            onChange={this.handleScheduleMessageChange}
                                            color="primary"/>
                                    }
                                    label="Agendar"/>
                            </div>
                        </div>
                        <div className="row">
                            <RadioGroup
                                className="radioButtonHolder col-12"
                                name="sendType"
                                value={sendType}
                                onChange={this.handleSendTypeChange}>
                                <div className="row fullWidth">
                                    <div className="col-12">
                                        <FormControlLabel
                                            className="radioButton"
                                            value="specificDate"
                                            label="Data específica"
                                            disabled={!+scheduleCommunication || !this.state.editable}
                                            control={<Radio />} />
                                        <div className="fieldHolder">
                                            <DatePicker
                                                fullWidth={true}
                                                id="sendDate"
                                                label="Data de Envio"
                                                format="DD/MM/YYYY"
                                                placeholder="Data de Envio"
                                                value={this.state.sendDate}
                                                locale="pt-PT"
                                                onChange={this.handleSendDateChange}
                                                disabled={!+scheduleCommunication || sendType === "recurrent" || !this.state.editable}
                                            />
                                        </div>
                                        <div className="fieldHolder">
                                            <TimePicker
                                                fullWidth={true}
                                                id="sendTime"
                                                label="Hora do Envio"
                                                value={this.state.sendTime}
                                                onChange={this.handleSendTimeChange}
                                                ampm={false}
                                                format="HH:mm"
                                                disabled={!+scheduleCommunication || sendType === "recurrent" || !this.state.editable}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row fullWidth">
                                    <div className="col-12">
                                        <FormControlLabel
                                            className="radioButton"
                                            value="recurrent"
                                            label="Recorrente"
                                            disabled={!+scheduleCommunication || !this.state.editable}
                                            control={<Radio />} />
                                        <div className="fieldHolder">
                                            <DatePicker
                                                fullWidth={true}
                                                id="startDate"
                                                label="Primeira Data"
                                                format="DD/MM/YYYY"
                                                placeholder="Primeira Data"
                                                value={this.state.startDate}
                                                locale="pt-PT"
                                                onChange={this.handleStartDateChange}
                                                disabled={!+scheduleCommunication || sendType === "specificDate" || !this.state.editable}
                                            />
                                        </div>
                                        <div className="fieldHolder required selectField">
                                            <FormControl fullWidth={true}>
                                                <InputLabel htmlFor="frequency">Periocidade</InputLabel>
                                                <Select id="frequency"
                                                        name="frequency"
                                                        value={this.state.frequency}
                                                        onChange={this.handleSelectChange}
                                                        disabled={!+scheduleCommunication || sendType === "specificDate" || !this.state.editable}
                                                        data-empty-error-message="Este campo não pode estar vazio">
                                                {optsFrequency}
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div className="fieldHolder">
                                            <TimePicker
                                                fullWidth={true}
                                                id="freqTime"
                                                label="Hora do Envio"
                                                value={this.state.freqTime}
                                                onChange={this.handleFreqTimeChange}
                                                ampm={false}
                                                format="HH:mm"
                                                disabled={!+scheduleCommunication || sendType === "specificDate" || !this.state.editable}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }} />
                                        </div>
                                    </div>
                                </div>
                            </RadioGroup>
                        </div>
                    </div>
                    }
                </div>
                <div className="row">
                    <div className="col-12 col-md-6 fieldHolder">
                        <TextField fullWidth={true}
                                   id="description"
                                   value={this.state.description}
                                   onChange={this.handleFieldChange}
                                   disabled={!this.state.editable}
                                   multiline={true}
                                   rows={4}
                                   label="Descrição" />
                    </div>
                    <div className="col-12 col-md-6 fieldHolder">
                        <TextField fullWidth={true}
                                   id="notes"
                                   value={this.state.notes}
                                   onChange={this.handleFieldChange}
                                   disabled={!this.state.editable}
                                   multiline={true}
                                   rows={4}
                                   label="Observações" />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 buttonsHolder">
                        <Button onClick={this.props.props.history.goBack} className="defaultButton" variant="contained">Voltar</Button>
                        {this.state.communicationId !== "New" && ((this.state.isSystem && this.accessLevel < 1) || (!this.state.isSystem && this.accessLevel <= 1)) &&
                            <Button onClick={this.handleDelete} className="button button-danger" variant="contained">Apagar Comunicação</Button>
                        }
                        {this.state.editable && <Button onClick={this.handleSave} className="button float-right" variant="contained" color="primary"><i className='fa fa-check'></i> Salvar</Button>}
                    </div>
                </div>
                {this.state.openModal && <ModalBox modalCallBack={this.state.modalCallBack} hideButtons={this.state.hideModalButtons} bigModal={this.state.bigModal} modalClass={this.state.modalClass} isActive={this.state.openModal} modalHtml={this.state.modalHtml} />}
            </div>
        );
    }
}

export default AddEditCommunication;
